import React, { useState } from 'react';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      question: "Como funciona esse sistema?",
      answer: "A empresa capta o cliente, identifica o serviço, dá um preço e, posteriormente, repassa o serviço para o parceiro cadastrado que poderá aceitar ou não."
    },
    {
      question: "Quanto é cobrado e como eu recebo?",
      answer: "Primeiro identificamos o serviço e damos um preço para o cliente. Antes de repassar o serviço ao parceiro, combinamos o valor que será pago ao profissional. Exemplo: se o cliente paga R$150 para trocar uma torneira, o parceiro pode receber R$100. Os valores variam de acordo com a cidade e o tipo de serviço."
    },
    {
      question: "Esse é um serviço registrado?",
      answer: "Não. É uma parceria sem vínculo empregatício. O parceiro é livre para aceitar ou recusar os serviços que desejar."
    },
    {
      question: "Preciso ter ferramentas próprias?",
      answer: "Sim. Cada parceiro deve ter suas próprias ferramentas para realizar os serviços que se cadastrar. A empresa não fornece ferramentas."
    },
    {
      question: "Preciso enviar currículo?",
      answer: "Não. Apenas o cadastro na plataforma já é suficiente."
    },
    {
      question: "Quem faz o pagamento e quando recebo?",
      answer: "O cliente paga à empresa, e a empresa paga ao parceiro o valor combinado. O pagamento é feito imediatamente após a conclusão do serviço, assim que o cliente confirmar que está tudo certo."
    },
    {
      question: "Quem vai pagar pelo meu serviço?",
      answer: "O serviço será pago imediatamente após a conclusão por nós."
    },
    {
      question: "Quanto vai ser pago pelo meu serviço?",
      answer: "Será feita uma avaliação de cada serviço junto ao parceiro. Em outras palavras, é você mesmo que vai dar o preço para execução daquele serviço oferecido."
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
      <div className="text-center mb-4">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">
          Perguntas Frequentes
        </h2>
        <p className="text-sm sm:text-base text-gray-600">
          Tire suas dúvidas sobre como funciona nossa plataforma
        </p>
      </div>

      <div className="space-y-2">
        {faqData.map((item, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-lg overflow-hidden transition-all duration-200"
          >
            <button
              onClick={() => toggleItem(index)}
              className="w-full px-3 py-3 sm:px-4 sm:py-4 text-left bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-inset transition-colors duration-200"
            >
              <div className="flex items-center justify-between">
                <h3 className="text-base sm:text-lg font-medium text-gray-900 pr-2 leading-tight">
                  {item.question}
                </h3>
                <div className="flex-shrink-0">
                  <svg
                    className={`w-4 h-4 sm:w-5 sm:h-5 text-primary-600 transition-transform duration-200 ${
                      openItems[index] ? 'rotate-180' : ''
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </button>
            
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                openItems[index] 
                  ? 'max-h-96 opacity-100' 
                  : 'max-h-0 opacity-0'
              }`}
            >
              <div className="px-3 py-3 sm:px-4 sm:py-4 bg-white border-t border-gray-100">
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Seção de contato e vídeo */}
      <div className="mt-4 p-3 bg-primary-50 rounded-lg border border-primary-200">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="w-4 h-4 text-primary-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="ml-2 flex-1">
            <h4 className="text-sm font-medium text-primary-800">
              Ainda tem dúvidas?
            </h4>
            <p className="text-sm text-primary-700 mt-1">
              Assista ao nosso{' '}
              <button
                onClick={() => {
                  const videoModal = document.getElementById('videoModal');
                  if (videoModal) {
                    videoModal.classList.remove('hidden');
                  }
                }}
                className="text-primary-600 underline hover:text-primary-800 transition-colors cursor-pointer"
              >
                vídeo explicativo
              </button>
              {' '}se ainda tiver dúvidas.
            </p>
          </div>
        </div>
      </div>

      {/* Modal do vídeo */}
      <div id="videoModal" className="hidden fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
        <div className="bg-white rounded-lg w-full max-w-4xl max-h-[95vh] flex flex-col">
          <div className="flex justify-between items-center p-3 sm:p-4 border-b flex-shrink-0">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900">Vídeo Explicativo</h3>
            <button
              onClick={() => {
                const videoModal = document.getElementById('videoModal');
                if (videoModal) {
                  videoModal.classList.add('hidden');
                }
                // Pausar o vídeo quando fechar o modal
                const video = document.getElementById('explicativoVideo');
                if (video) {
                  video.pause();
                }
              }}
              className="text-gray-400 hover:text-gray-600 p-1"
            >
              <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="flex-1 p-2 sm:p-4 overflow-hidden">
            <div className="w-full h-full flex items-center justify-center">
              <video
                id="explicativoVideo"
                className="w-full h-auto max-h-full rounded"
                controls
                preload="metadata"
                style={{ maxHeight: 'calc(95vh - 80px)' }}
              >
                <source src="/video explicativo.mp4" type="video/mp4" />
                <source src="/video explicativo.webm" type="video/webm" />
                <p className="text-center text-gray-600 py-8">
                  Seu navegador não suporta vídeos HTML5. 
                  <a href="/video explicativo.mp4" className="text-primary-600 underline" download>
                    Clique aqui para baixar o vídeo
                  </a>
                </p>
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
